import { createGlobalStyle } from "styled-components";

import * as vars from "./style-vars";

export const StylesReset = createGlobalStyle`
  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    font-family: ${vars.fontDefault};
    color: ${vars.colorFontDefault};
    overflow: hidden;
  }
  
  a {
    color: inherit;
    text-decoration: none;
  }
  
  h1, h2, h3, h4,
  h5, h6 {
    margin: 0;
    font-weight: 300;
    color: ${vars.colorFontDefault};
  }
  
  h1 {
    font-size: ${vars.font24.fontSize};
    line-height: ${vars.font24.lineHeight};
  }
  h2 {
    font-size: ${vars.font20.fontSize};
    line-height: ${vars.font20.lineHeight};
  }
  h3 {
    font-size: ${vars.font16.fontSize};
    line-height: ${vars.font16.lineHeight};
  }
  h4 {
    font-size: ${vars.font14.fontSize};
    line-height: ${vars.font14.lineHeight};
  }
  h5 {
    font-size: ${vars.font12.fontSize};
    line-height: ${vars.font12.lineHeight};
  }
  h6 {
    font-size: ${vars.font11.fontSize};
    line-height: ${vars.font11.lineHeight};
  }

  .hidden {
    display: none;
  }
  
  button {
    padding: 0;
    border: none;
    outline: none;
    font: inherit;
    background: none;
  }

  // AntD overrides

  .ant-notification-notice {
    svg.svg-inline--fa {
      vertical-align: 0px;
    }
  }

  .ant-dropdown {
    &.ant-dropdown-placement-bottomRight .ant-dropdown-menu-item {
      display: flex;
    }
  }

`;
